import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import eventBus from '@/utils/eventBus';
import { EBusinessUserType } from '@/store/modules/businessTypes';
import { getBillingIsPending } from '@/utils/billing';
import BillingService from '@/api/BillingService';

interface SetUpSellCoinsParams {
  managerRole: EBusinessUserType;
  notification: (message: string, type: string) => void;
  welcomeCtaText?: string;
  setAccessedEmptyState: () => void;
  inactiveBilling: boolean;
}

export async function setUpSellCoins(
  params: SetUpSellCoinsParams
): Promise<boolean> {
  const {
    inactiveBilling,
    managerRole,
    notification,
    welcomeCtaText,
    setAccessedEmptyState
  } = params;

  if (inactiveBilling) {
    if (managerRole !== EBusinessUserType.OWNER) {
      notification(
        "You don't have permission to upgrade your account",
        'error'
      );
      return false;
    }

    const modal = getBillingIsPending() ? 'Acceptance' : 'Reactivation';
    const billingService = new BillingService();

    try {
      const {
        overview,
        features
      } = await billingService.getOverviewAndActivedFeatures(
        modal !== 'Reactivation'
      );

      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `coinNetwork${modal}Modal`,
          hideCancelButton: false,
          icon: '',
          mobileFullScreen: true
        }),
        {
          welcomeCtaText,
          onSuccess: () => {
            setAccessedEmptyState();
            return true;
          },
          subscription: overview,
          features,
          origin: 'Empty State Sell Coins'
        }
      );
      return true;
    } catch (error) {
      console.error('Error setting up sell coins:', error);
      return false;
    }
  }

  setAccessedEmptyState();
  return true;
}
